import PropTypes from 'prop-types';

const lazyNavigationEntity = () => NavigationEntity;

const NavigationEntity = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  path: PropTypes.string,
  active: PropTypes.bool,
  children: PropTypes.arrayOf(lazyNavigationEntity),
  className: PropTypes.string,
  customNavLinks: PropTypes.arrayOf(PropTypes.object)
});

export default NavigationEntity;



// WEBPACK FOOTER //
// ./src/types/NavigationEntity.js